import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

const Loading = () => <Spin indicator={<LoadingOutlined style={{ fontSize: 40 }} spin />} />;
export default Loading;

/**
* loading spin
*/
export const ChartsLoading = (props: { height: number | string; width?: string; }) => {
    return (
        <div
            className="w-full flex flex-wrap justify-center h-full items-center bg-white"
            style={{ height: props.height, width: props.width }}
        >
            <Spin size="large" className="" />
        </div>
    );
};